<template>
  <div>
    <b-card
      no-body
      class="liveinfo-form"
    >
      <div class="m-0">
        <b-row>
          <b-col
            cols="12"
            md="10"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <v-select
              v-model="query.contractId"
              :options="codes.contracts"
              placeholder="계약명"
              :reduce="option => option.code"
              class="el-def"
            />

            <b-form-input
              v-model="query.title"
              placeholder="제목"
              class="el-def"
              style="width:480px;"
              @keyup.enter="refetchData()"
            />
          </b-col>
          <!-- Search -->
          <b-col
            cols="12"
            md="2"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="primary"
              class="btn-search"
              @click.prevent="refetchData()"
            >
              조회
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start"
          >
            <h5 class="mb-0 ml-50">
              게시글 리스트 [{{ totalRecords }}] 건
            </h5>
          </b-col>
        </b-row>
      </div>
      <b-table
        ref="refInfoTable"
        primary-key="id"
        :items="fetchInfos"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDesc"
        responsive
        sticky-header
        selectable
        select-mode="single"
        class="position-relative"
        @row-selected="onRowSelectedInfo"
      >
        <template #cell(startDate)="data">
          <span class="text-nowrap">
            {{ data.value | $dateFormatter('YYYY-MM-DD') }}
            ~
            {{ data.item.endDate | $dateFormatter('YYYY-MM-DD') }}
          </span>
        </template>
      </b-table>
      <b-pagination
        v-model="currPage"
        :total-rows="totalRecords"
        limit="10"
        per-page="10"
        align="center"
      />
    </b-card>

    <b-card
      no-body
    >
      <b-row
        class="mb-2"
      >
        <b-col
          md="8"
          class="d-flex align-items-center justify-content-start"
        >
          <b-form-datepicker
            v-model="query.searchStartDate"
            class="el-def"
            placeholder="조회기간(Fr)"
            style="width: 240px"
          />
          <label
            class="ml-50 mr-50"
          >~</label>
          <b-form-datepicker
            v-model="query.searchEndDate"
            class="el-def"
            placeholder="조회기간(To)"
            style="width: 240px"
          />
          <label class="ml-50">(*당일데이터 조회 불가)</label>
        </b-col>

        <b-col
          md="4"
          class="d-flex align-items-center justify-content-end"
        >
          <b-button
            variant="primary"
            class="btn-search"
            @click.prevent="fetchStatData()"
          >
            조회
          </b-button>
          <b-button
            variant="outline-dark"
            class="btn-search ml-1"
            :disabled="!query.deskContentId"
            @click.prevent="excelDownload()"
          >
            <span>엑셀 다운로드</span>
          </b-button>
        </b-col>

      </b-row>

      <detail-grid
        :content-id="query.deskContentId"
        :data="contentStatData"
      />
    </b-card>

  </div>
</template>

<script>
import axios from "@axios"
import dayjs from 'dayjs'
import vSelect from 'vue-select'
import { cloneDeep } from 'lodash'
import {
  ref, watch, onMounted, getCurrentInstance, computed, nextTick,
} from "@vue/composition-api"
import { useToast } from "vue-toastification/composition"
import {
  required, after, before, dateBetween,
} from "@validations"
import { extend } from "vee-validate"
import { errorFormatter, dateFormatter } from "@core/utils/filter"
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"
import DetailGrid from '../grid/ContentDetailGrid.vue'

export default {
  components: {
    vSelect,
    DetailGrid,

  },

  setup() {
    onMounted(() => {
      resetInfoData()
      fetchCodes()
      getDiseases()
    })

    const toast = useToast()
    const instance = getCurrentInstance()
    const refs = instance.proxy.$refs
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }
      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    // Main Table Config
    const infoInitState = {
      id: 0,
      contentType: 1, // 1: 머테리얼, 2: 웨비나
      title: "",
      subText: "",
      deskContractId: null,
      deskDiseaseId: null,
      startDate: null,
      endDate: null,
      linkUrl: null,
      watchLinkUrl: null,
      watchStartDate: dayjs().format('YYYY-MM-DD'),
      watchStartTime: null,
      watchEndTime: null,
      isShow: true,
      isSpuUse: false,
      spuContent: null,
      isNpuUse: false,
      isCancel: false,
      isLive: false,
      spus: [], // 스케줄팝업 리스트
      npus: [], // 시청알림팝업 리스트
    }
    const infoData = ref({ ...infoInitState })
    const contentStatData = ref([])

    const resetInfoData = () => {
      Object.assign(infoData.value, infoInitState)

      nextTick(() => {
      })
    }

    const showSpuContentPreview = ref(false)

    watch(() => infoData.value.deskContentId, newVal => {
      if (newVal) {
        changeContract(newVal)
      } else {
        contractFr.value = null
        contractTo.value = null
      }
    })

    const changeNpuBeforeMinute = () => {
      refs.npuRules.validate()
    }

    const currItem = ref({})
    const refInfoTable = ref(null)
    const sortBy = ref("createDate")
    const isSortDesc = ref(true)
    const currPage = ref(1)
    const totalRecords = ref(0)
    const tableColumns = [
      {
        key: "id", label: "게시글ID", sortable: false, thStyle: { width: '120px' },
      },
      {
        key: "contractTitle", label: "계약명", sortable: false, thStyle: { width: '240px' },
      },
      {
        key: "contentTypeName", label: "구분", sortable: false, thStyle: { width: '120px' },
      },
      {
        key: "diseaseName", label: "관련 질환", sortable: false, thStyle: { width: '200px' },
      },
      { key: "title", label: "제목", sortable: false },
      {
        key: "startDate", label: "게시 기간", sortable: false, thStyle: { width: '220px' },
      },
      {
        key: "postStatusName", label: "게시상태", sortable: false, thStyle: { width: '120px' },
      },
    ]
    const refetchData = () => {
      refInfoTable.value.refresh()
    }
    watch([currPage], () => {
      refetchData()
    })
    const onRowSelectedInfo = items => {
      const item = items[0]
      if (item) {
        getStatInfo(item.id)
        currItem.value = item
      }
    }
    // Main Table Config End.

    const showDeskDiseaseManage = ref(false)
    const onClickDiseaseShowButton = () => {
      showDeskDiseaseManage.value = true
      refs.diseaseShowButton.blur()
    }
    const deskDiseaseManage = {
      close: rs => {
        showDeskDiseaseManage.value = false
        if (rs) {
          getDiseases()
        }
      },
    }

    const codes = ref({
      isShowType: [
        { label: '노출(등록 즉시 노출됨)', code: true },
        { label: '숨김(요양기관마다 직접 노출 처리 필요)', code: false },
      ],
      contentType: [],
      postStatusType: [],
      contracts: [],
      validContracts: [],
      diseases: [],
      npuBeforeMinutes: [
        { label: "5분전", code: 5 },
        { label: "10분전", code: 10 },
        { label: "20분전", code: 20 },
        { label: "30분전", code: 30 },
        { label: "1시간전", code: 60 },
        { label: "1일전", code: 1440 },
        { label: "3일전", code: 4320 },
        { label: "7일전", code: 10080 },
      ],
      durations: [
        { label: "10초", code: 10 },
        { label: "30초", code: 30 },
        { label: "1분", code: 60 },
        { label: "5분", code: 300 },
        { label: "10분", code: 600 },
        { label: "30분", code: 1800 },
      ],
    })

    const fetchCodes = () => {
      axios.get('/fa/desk-info/codes')
        .then(rs => {
          const {
            deskInfoContentType,
            postStatusType,
            contracts,
            validContracts,
          } = rs.data
          codes.value.contentType = deskInfoContentType
          codes.value.postStatusType = postStatusType
          codes.value.contracts = contracts
          codes.value.validContracts = validContracts

          refetchData()
        })
        .catch(() => {
          pushToast('danger', '코드 데이터를 불러오는데 실패하였습니다.')
        })
    }

    const query = ref({
      contractId: null,
      searchStartDate: dayjs().add(-1, 'month').format('YYYY-MM-DD'),
      searchEndDate: dayjs().add(-1, 'day').format('YYYY-MM-DD'),
      title: null,
      deskContentId: null,
    })

    const fetchInfos = (ctx, callback) => {
      axios
        .post("/fa/desk-info/list", {
          search: {
            contractId: query.value.contractId,
            contentType: null,
            postStatus: null,
            startDate: null,
            endDate: null,
            title: query.value.title,
          },
          sort: {
            predicate: sortBy.value,
            reverse: isSortDesc.value,
          },
          pagination: {
            number: currPage.value,
          },
        })
        .then(rs => {
          const { items, totalRecord } = rs.data
          callback(items)
          totalRecords.value = totalRecord
        })
        .catch(() => {
          pushToast('danger', '데이터 조회에 실패하였습니다.')
        })
    }

    const getStatInfo = id => {
      query.value.deskContentId = id

      fetchStatData()
    }

    const contractFr = ref(null)
    const contractFrDisp = computed(() => dateFormatter(contractFr.value))
    const contractTo = ref(null)
    const contractToDisp = computed(() => dateFormatter(contractTo.value))
    const changeContract = contractId => {
      axios
        .get(`/fa/desk-contract/${contractId}`)
        .then(rs => {
          contractFr.value = rs.data.startDate
          contractTo.value = rs.data.endDate
        })
        .catch(() => {
          pushToast('danger', '계약 조회에 실패하였습니다.')
        })
    }

    const getDiseases = () => {
      axios.post('/fa/desk-disease/list', {
        search: {},
        sort: {
          predicate: 'createDate',
          reverse: true,
        },
      })
        .then(rs => {
          const { items } = rs.data
          codes.value.diseases = items.map(p => ({
            code: p.id,
            label: p.disease,
          }))
        })
        .catch(() => {
          pushToast('danger', '관련 질환 조회에 실패하였습니다.')
        })
    }

    const fetchStatData = () => {
      if (query.value.deskContentId == null) {
        return
      }

      const frDate = dayjs(query.value.searchStartDate)
      const toDate = dayjs(query.value.searchEndDate)

      if (Math.abs(frDate.diff(toDate, 'day')) > 30) {
        toast({
          component: ToastificationContent,
          props: {
            title: '조회 기간은 최대 30일을 넘을 수 없습니다.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }

      axios.get("/fa/desk-statistics/content", {
        params: {
          startDate: query.value.searchStartDate ? `${query.value.searchStartDate}T00:00:00` : null,
          endDate: query.value.searchEndDate ? `${query.value.searchEndDate}T23:59:59` : null,
          deskInfoId: query.value.deskContentId,
        },
      })
        .then(rs => {
          const { data } = rs

          contentStatData.value = data
        })
        .catch(() => {
          pushToast('danger', '데이터 조회 중 오류가 발생하였습니다.')
        })
    }

    const excelDownload = async () => {
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet("sheet1")

      worksheet.addRow()

      worksheet.getCell('A1').value = '게시글ID'
      worksheet.getCell('B1').value = '계약명'
      worksheet.getCell('C1').value = '구분'
      worksheet.getCell('D1').value = '관련질환'
      worksheet.getCell('E1').value = '제목'
      worksheet.getCell('F1').value = '게시 기간'
      worksheet.getCell('G1').value = '게시 상태'

      worksheet.addRow()

      worksheet.getCell('A2').value = currItem.value.id
      worksheet.getCell('B2').value = currItem.value.contractTitle
      worksheet.getCell('C2').value = currItem.value.contentTypeName
      worksheet.getCell('D2').value = currItem.value.diseaseName
      worksheet.getCell('E2').value = currItem.value.title
      worksheet.getCell('F2').value = `${dayjs(currItem.value.startDate).format('YYYY-MM-DD')} ~ ${dayjs(currItem.value.endDate).format('YYYY-MM-DD')}`
      worksheet.getCell('G2').value = currItem.value.postStatusName

      worksheet.addRow()

      worksheet.getCell('A4').value = '상세 코드'
      worksheet.getCell('B4').value = '게시글 노출 수'
      worksheet.getCell('C4').value = '게시글 클릭 수'
      worksheet.getCell('D4').value = '시청 알림 팝업 노출 수'
      worksheet.getCell('E4').value = '시청 알림 팝업 클릭 수'
      worksheet.getCell('F4').value = '스케줄 알림 팝업 노출 수'
      worksheet.getCell('G4').value = '스케줄 알림 팝업 클릭 수'

      worksheet.columns = [
        { key: "entryCode", width: 15 },
        { key: "homePopupShowCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "homePopupClickCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "noticePopupShowCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "noticePopupClickCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "schedulePopupShowCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "schedulePopupClickCount", width: 15, style: { numFmt: '#,##0' } },
      ]

      const startRow = 3

      const stats = contentStatData.value

      stats.map(x => {
        const record = {
          entryCode: x.entryCode,
          homePopupShowCount: x.homePopupShowCount,
          homePopupClickCount: x.homePopupClickCount,
          noticePopupShowCount: x.noticePopupShowCount,
          noticePopupClickCount: x.noticePopupClickCount,
          schedulePopupShowCount: x.schedulePopupShowCount,
          schedulePopupClickCount: x.schedulePopupClickCount,
        }

        worksheet.addRow(record)
      })

      // worksheet.mergeCells(`A${endRow}:B${endRow}`)

      worksheet.eachRow({ includeEmpty: true }, (row, number) => {
        row.eachCell({ includeEmpty: true }, cell => {
          if (number === 1 || number === 4) { // 헤더 스타일 적용
            // eslint-disable-next-line no-param-reassign
            cell.font = {
              bold: true,
            }

            // eslint-disable-next-line no-param-reassign
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'D3D3D3' },
            }
          }

          // eslint-disable-next-line no-param-reassign
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          }

          if (cell.value === '소계' || cell.value === '합계') {
            // eslint-disable-next-line no-param-reassign
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'center',
            }
          } else {
            // eslint-disable-next-line no-param-reassign
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'left',
            }
          }
        })
      })

      const mimeType = {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }

      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], mimeType)
      saveAs(blob, "데스크인포 게시글 통계.xlsx")
    }

    return {
      query,
      codes,
      tableColumns,
      refInfoTable,
      sortBy,
      isSortDesc,
      refetchData,
      currPage,
      totalRecords,
      infoData,
      resetInfoData,
      onRowSelectedInfo,
      changeContract,
      contractFr,
      contractFrDisp,
      contractTo,
      contractToDisp,
      showSpuContentPreview,

      after,
      before,
      required,
      dateBetween,
      fetchCodes,
      fetchInfos,

      showDeskDiseaseManage,
      deskDiseaseManage,
      onClickDiseaseShowButton,
      changeNpuBeforeMinute,

      contentStatData,
      getStatInfo,
      fetchStatData,
      excelDownload,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.spu-preview-width {
  width: 270px !important;
}
.spu-preview-body {
  padding: 3px 0px 0px 0px;
  overflow-y: auto;
  height: 185px !important;
}
</style>
